import request from ".";

/**新建产品预算 */
function newProductBudget(data){
  return request('/product/addPreSaleProduct', 'post', data)
}

/**修改产品预算 */
function updateProductBudget(data){
  return request('/product/updatePreSaleProduct', 'post', data)
}

/**获取选品利润预算列表 */
function getProductBudgetList(data){
  return request('/product/getProduct/filter', 'post', data)
}

/**删除选品利润预算 */
function deleteProductBudget(id){
  request('/product/deletePreSaleProduct/' + id, 'post')
}

export default{
  newProductBudget, getProductBudgetList, deleteProductBudget, updateProductBudget
}
